import { PlayerForSaveDto, SavePlayerWithBioPayload } from '@/api/models';
import { CurrentContract } from '@/api/models/PlayerContractHistory';
import { SavePlayerWithBioResponse } from '@/api/models/SavePlayerWithBioResponse';
interface ICreateNewPlayerProps {
  response: SavePlayerWithBioResponse;
  payload: SavePlayerWithBioPayload;
}

export const createNewPlayer = ({ response, payload }: ICreateNewPlayerProps): PlayerForSaveDto => {
  const responseData = response.playerResults.data;
  const responsePlayerBio = Array.isArray(responseData.playerBio) ? responseData.playerBio[0] : responseData.playerBio;

  return {
    // --- SharedModel ---
    isActive: responseData.isActive,
    sortId: 0,
    modifyDate: new Date(),
    modifyUserGuid: '',
    modifyUserName: '',
    createDate: new Date(),
    createUserGuid: '',
    rowGuid: '',
    tstamp: '',

    // --- PlayerForSaveDto ---
    addresses: [],
    bsgEventDetail: [],
    clubImage: [],
    firstName: responseData.firstName,
    lastName: responseData.lastName,
    fullName: responseData.fullName,
    orderAccountId: 0, // not returned by API
    phonesResponse: [],
    playerBio: responsePlayerBio,
    currentPlayerRankingsPlayerId: '',

    playerBioDto: {
      // --- SharedModel ---
      isActive: responseData.isActive,
      sortId: 0,
      modifyDate: new Date(),
      modifyUserGuid: '',
      modifyUserName: '',
      createDate: new Date(),
      createUserGuid: '',
      rowGuid: '',
      tstamp: '',

      // --- PlayerBioDto ---
      caddy: '',
      email: '',
      fullName: responseData.fullName,
      manager: '',
      nationality: '',
      notes: '',
      playerBioId: responsePlayerBio.playerBioId,
      playerCollegeLookupId: 0,
      playerCollegeLookupName: '',
      playerId: responseData.playerId,

      playerStatusLookupId: responsePlayerBio.playerStatusLookupId,
      playerStatusLookupName: payload.playerBio.playerStatusLookupName,

      playerRegionLookupId: responsePlayerBio.playerRegionLookupId,
      playerRegionLookupName: payload.playerBio.playerRegionLookupName,

      playerInternalStatusLookupId: responsePlayerBio.playerInternalStatusLookupId,
      playerInternalStatusLookupName: payload.playerBio.playerInternalStatusLookupName,

      playerSupportLookupId: 0,
      playerSupportLookupName: '',
      playerYearLookupId: 0,
      playerYearLookupName: '',
      tourId: responsePlayerBio.tourId,
    },

    playerId: responseData.playerId,
    tourBagBsg: [],
    tourBagDetail: [],
    tourBagIronDetail: [],
    tourBagMstr: [],
    tourPlayer: [],
    defaultTourId: responsePlayerBio.tourId,
    defaultTourName: payload.defaultTourName,
    tours: responsePlayerBio.tourId ? [responsePlayerBio.tourId] : [],
    contract: {} as CurrentContract,
  };
};
